<template>
    <b-container fluid>
        <b-row>
            <b-col xl="12" lg="12" sm="12">
                <iq-card>
                    <template v-slot:body>
                        <!-- <div class="text-right">
                            <b-button class="btn-sm" variant="primary" @click="pdfExport">
                                {{  $t('globalTrans.export_pdf') }}
                            </b-button>
                        </div> -->
                        <b-row>
                            <b-overlay :show="unitLoad">
                                <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                    <b-row>
                                        <b-col xs="12" sm="12" md="6" lg="4" xl="4">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="12"
                                                label-for="fiscal_year_id"
                                            >
                                                <template v-slot:label>
                                                {{ $t('globalTrans.fiscal_year')}}
                                                </template>
                                                <b-form-input
                                                readonly
                                                id="fiscal_year_id"
                                                v-model="checklist.fis_name"
                                                ></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col xs="12" sm="12" md="6" lg="4" xl="4">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="12"
                                                label-for="criteria_name"
                                            >
                                                <template v-slot:label>
                                                {{ $t('child_configuration.criteria_name_en')}}
                                                </template>
                                                <b-form-input
                                                readonly
                                                id="criteria_name"
                                                v-model="checklist.criteria_name"
                                                ></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col xs="12" sm="12" md="6" lg="4" xl="4">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="12"
                                                label-for="criteria_name_bn"
                                            >
                                                <template v-slot:label>
                                                {{ $t('child_configuration.criteria_name_bn')}}
                                                </template>
                                                <b-form-input
                                                readonly
                                                id="criteria_name_bn"
                                                v-model="checklist.criteria_name_bn"
                                                ></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <br>
                                        <b-col>
                                            <hr>
                                            <b-table-simple bordered>
                                                <thead class="bg-primary">
                                                    <tr>
                                                        <th width="100px">{{ $t('globalTrans.sl_no') }}</th>
                                                        <th scope="col">{{ $t('child_configuration.checklist_name_en') }}</th>
                                                        <th scope="col">{{ $t('child_configuration.checklist_name_bn') }}</th>
                                                    </tr>
                                                </thead>
                                                <b-tbody>
                                                    <b-tr v-for="(item, index) in checklist.checklist_details" :key='index'>
                                                        <b-td>{{ $n(index + 1) }}</b-td>
                                                        <b-td>{{ item.checklist_name }}</b-td>
                                                        <b-td>{{ item.checklist_name_bn }}</b-td>
                                                    </b-tr>
                                                </b-tbody>
                                            </b-table-simple>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-overlay>
                        </b-row>
                    </template>
                </iq-card>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import { childServiceBaseUrl } from '@/config/api_config'
import ExportPdf from './export-e_checklist'
import ReportHeading from '@/Utils/report-head'

export default {
    props: ['id'],
    components: {
    },
    computed: {
          fiscalYearList: function () {
            return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
        }
    },
    data () {
        return {
            saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
            checklist: {
            },
            unitLoad: false
        }
    },
    mounted () {
        core.index()
    },
    created () {
        if (this.id) {
            const tmp = this.getChecklistData()
            this.checklist = tmp
        }
    },
    methods: {
        async headerName () {
            const headdata = await ReportHeading.getReportHead(childServiceBaseUrl, 'configuration/report-heading/detail', 6)
            this.reportHeadData = headdata
            this.loaded = true
        },
        getFiscalYName (fisId) {
            const product = this.$store.state.commonObj.fiscalYearList.find(product => product.value === fisId)
            if (this.$i18n.locale === 'bn') {
                return product.text_bn
            } else {
                return product.text_en
            }
        },
        getChecklistData () {
            const tmpData = this.$store.state.list.find(item => item.id === this.id)
            return JSON.parse(JSON.stringify(tmpData))
        },
        pdfExport () {
            const reportTitle = this.$t('child_configuration.e_checklist')
            ExportPdf.exportPdfDetails(childServiceBaseUrl, 'configuration/report-heading/detail', 3, reportTitle, this.checklist, this.checklist_data, this)
        }
    }
}
</script>
